import type { NavigationGuardWithThis } from 'vue-router';

import { useRoleCheck } from '@/composables/useRoleCheck';
import { Constants } from '@/constants';
import { useConfigurationStore } from '@/stores';

// A page's blocks, like `/files`, are for administrators only, where a project's blocks admit editors too. An editor
// can log in to the admin, so one who opens a page route is sent home rather than shown a screen the API refuses. The
// API serves a superadmin as an administrator flagged `isSuperadmin`, so the rule lets them in. `main.ts` loads the
// user before it installs the router, so the user is known here on the first navigation too.
export const administratorsOnly: NavigationGuardWithThis<undefined> = (_to, _from, next) => {
  const { isUserAuthorized } = useRoleCheck({ rolesAllowed: [Constants.User.Role.ADMIN] });
  if (isUserAuthorized.value) {
    next();
  } else {
    next('/');
  }
};

// The Pages screens stay hidden until the `pages` release flag is on, so an administrator who opens one by its URL is
// sent home. The flag decides nothing about access: the API serves those routes to administrators either way. `main.ts`
// loads the configurations before it installs the router, so the flag is known on the first navigation too.
export const pagesReleased: NavigationGuardWithThis<undefined> = (_to, _from, next) => {
  if (useConfigurationStore().isFeatureEnabled('pages')) {
    next();
  } else {
    next('/');
  }
};
